import { render, staticRenderFns } from "./RouteLeg.vue?vue&type=template&id=3b1b1c70&scoped=true&"
import script from "./RouteLeg.vue?vue&type=script&lang=js&"
export * from "./RouteLeg.vue?vue&type=script&lang=js&"
import style0 from "./RouteLeg.vue?vue&type=style&index=0&id=3b1b1c70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b1c70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VTimelineItem,VTooltip})
